import React, {Component} from 'react'
import {Badge} from 'reactstrap'
import PropTypes from 'prop-types'
import timeHumanize from "../../helpers/timeHumanize"
import getLocationType from "../../../vietnameses/getLocationType"
import classNames from 'classnames'
import Shipped from "./shipped/Shipped"
import {listLocal} from "../../helpers/filtersTable"
import {Link} from "react-router-dom"

class RowBoxItem extends Component {
    _genStatusLabel = () => {
        const {item} = this.props
        const {shipment_status} = item
        const statusLabel = shipment_status === 'received' ? <Badge color="success">Received</Badge> :
            <Badge color="secondary">Pending</Badge>

        return statusLabel
    }

    _ShippingCarrierName = (carrier) => {
        if (!!carrier) {
            const shippingName = listLocal.filter(item => item.value === carrier)

            return shippingName[0]
        }
    }

    render() {
        const {item, index, fetchListBoxesItems} = this.props
        const {
            item_number,
            item_index,
            product,
            created,
            labelDetails,
            location_type,
            box,
            shipment_status,
            received_at,
            shipped_at,
            shipping_time,
            warehouse_id
        } = item
        const {size, type} = product
        const {partnerTrackingNumber} = Object.assign({}, labelDetails)
        const {_id, id, shipping_carrier} = Object.assign({}, box)
        const status = this._genStatusLabel()
        const carrierName = this._ShippingCarrierName(shipping_carrier)

        return (
            <tr className={classNames("RowBoxItem", location_type)}>
                <td>{index + 1}</td>
                <td><strong>#{item_number}_{item_index}</strong></td>
                <td>{id ? <Link to={`/next-boxes/${_id}`}>{id}</Link> : '--'}</td>
                <td>{type}</td>
                <td>{size}</td>
                <td>{getLocationType(location_type)}</td>
                <td>{!!carrierName && carrierName.name}{!!warehouse_id && `(${warehouse_id})`}</td>
                <td>{partnerTrackingNumber || '--'}</td>
                <td>{timeHumanize(created)}</td>
                <td>{timeHumanize(received_at)}</td>
                <td>{timeHumanize(shipped_at)}</td>
                <td>{shipping_time}</td>
                <td>{status}</td>
                {
                    shipment_status === 'pending' ?
                        <td><Shipped fetchListBoxesItems={fetchListBoxesItems} itemId={item._id}/></td>
                        : <td/>
                }
            </tr>
        )
    }
}

RowBoxItem.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    fetchListBoxesItems: PropTypes.func.isRequired
}

export default RowBoxItem
